import { render, staticRenderFns } from "./ObjectiveEvidenceList.vue?vue&type=template&id=08e56cd0&scoped=true&"
import script from "./ObjectiveEvidenceList.vue?vue&type=script&lang=js&"
export * from "./ObjectiveEvidenceList.vue?vue&type=script&lang=js&"
import style0 from "./ObjectiveEvidenceList.vue?vue&type=style&index=0&id=08e56cd0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e56cd0",
  null
  
)

export default component.exports